import React from 'react'
import { FormFieldInterface } from 'src/shared/types/entities/form-interface'
import { BasePublisherBaseField } from '../../base-publisher-field/base-publisher-base-field'
import { useFormField } from '../hooks/use-form-field'

interface FormEmailFieldSubEntityProps {
  fieldSubEntity: FormFieldInterface
}

export const FormEmailFieldSubEntity = ({
  fieldSubEntity,
}: FormEmailFieldSubEntityProps) => {
  const { value, onChange, errors } = useFormField({ fieldSubEntity })
  return (
    <BasePublisherBaseField
      type="email"
      entity={fieldSubEntity}
      value={value}
      onChange={onChange}
      errors={errors}
    />
  )
}
